import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { appendQueryParamIfNotEmpty, formatDate } from '../../../constants/hookConstants';
import { handleApiError } from '../../requestHelpers/requestHelpers';

export interface ManualSyncDateRangeParams {
  from: Dayjs | null;
  to: Dayjs | null;
}
export const useSyncOrganizationByDateRange = () => {
  const { t } = useTranslation();

  return useMutation(
    ({ from, to }: ManualSyncDateRangeParams) => {
      const queryParams = new URLSearchParams();
      appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
      appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

      return dataFetch.post(
        `${CORE_API_SUFFIX}ad/build/manual?${queryParams.toString()}`,
      );
    },
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('rebuildAdsForDateRangeSuccess'), 'success');
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
